export class Offer {

    public static createFromProfileData(profile: any): Offer {
        return new Offer(profile.offerId, profile.offerName, profile.isDefault, profile.isExclusive, profile.isPrepaid, profile.hasConference, profile.isDemo);
    }

    public static offerComparator(offer1: Offer, offer2: Offer) {
        const offerOrder = ["Essential", "Business", "Enterprise", "Voice", "Room", "Conference"];

        // Handle "Essential" offer
        if (offer1.isEssential()) { return -1; }
        if (offer2.isEssential()) { return 1; }

        // Handle "demo" offers (always on top)
        if (offer1.isDemo && !offer2.isDemo) { return -1; }
        if (!offer1.isDemo && offer2.isDemo) { return 1; }

        // Handle "Conference" offers (always at bottom)
        if (offer1.hasConference && !offer2.hasConference) { return 1; }
        if (!offer1.hasConference && offer2.hasConference) { return -1; }

        // Handle offers when both are "demo" offers or other type of offers
        let orderIndex1 = offerOrder.findIndex((order) => {
            return offer1.name.startsWith(order); // "Enterprise demo" and "enterprise" must have the same index
        });
        let orderIndex2 = offerOrder.findIndex((order) => {
            return offer2.name.startsWith(order); // "Enterprise demo" and "enterprise" must have the same index
        });
        // unknown offers are grouped at the bottom
        orderIndex1 = orderIndex1 === -1 ? offerOrder.length : orderIndex1;
        orderIndex2 = orderIndex2 === -1 ? offerOrder.length : orderIndex2;

        if (orderIndex1 < orderIndex2) { return -1; }
        if (orderIndex1 > orderIndex2) { return 1; }
        // offer 1 and 2 have same order index
        // reverse sort when demo (ie. "enterprise demo" before "enterprise")
        if (offer1.isDemo) { return -1; }
        if (offer2.isDemo) { return 1; }

        // Prepaid offers placed at the bottom
        if (offer1.isPrepaid && !offer2.isPrepaid) { return 1; }
        if (!offer1.isPrepaid && offer2.isPrepaid) { return -1; }
        // Sort by name
        if (offer1.name < offer2.name) { return -1; }
        if (offer1.name > offer2.name) { return 1; }
        return 0;
    }

    public id: string;
    public name: string;
    public isDefault: boolean = false;
    public isExclusive: boolean = false;
    public hasConference: boolean = false;
    public isPrepaid: boolean = false;
    public isDemo: boolean = false;

    constructor(id: string, name: string, isDefault: boolean, isExclusive: boolean, isPrepaid: boolean, hasConference: boolean, isDemo: boolean) {
        this.id = id;
        this.name = name || "";
        this.isDefault = isDefault;
        this.isExclusive = isExclusive;
        this.isPrepaid = isPrepaid;
        this.hasConference = hasConference;
        this.isDemo = isDemo;
    }

    public isEnterprise(): boolean { return this.name.toLowerCase().includes("enterprise"); }
    public isBusiness(): boolean { return this.name.toLowerCase().includes("business"); }
    public isEssential(): boolean { return this.isDefault; }
}
